import { Injectable } from '@angular/core';

@Injectable()
export class SingleSiteAnalysisContext {
    studyId: number;
}
